/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnectionScheduleSitesConfig } from './ICRTouchConnectionScheduleSitesConfig';
import {
    ICRTouchConnectionScheduleSitesConfigFromJSON,
    ICRTouchConnectionScheduleSitesConfigFromJSONTyped,
    ICRTouchConnectionScheduleSitesConfigToJSON,
    ICRTouchConnectionScheduleSitesConfigToJSONTyped,
} from './ICRTouchConnectionScheduleSitesConfig';

/**
 * 
 * @export
 * @interface UpdateIcrTouchConnectionScheduleSitesConfigResponse
 */
export interface UpdateIcrTouchConnectionScheduleSitesConfigResponse {
    /**
     * 
     * @type {ICRTouchConnectionScheduleSitesConfig}
     * @memberof UpdateIcrTouchConnectionScheduleSitesConfigResponse
     */
    data: ICRTouchConnectionScheduleSitesConfig;
}

/**
 * Check if a given object implements the UpdateIcrTouchConnectionScheduleSitesConfigResponse interface.
 */
export function instanceOfUpdateIcrTouchConnectionScheduleSitesConfigResponse(value: object): value is UpdateIcrTouchConnectionScheduleSitesConfigResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateIcrTouchConnectionScheduleSitesConfigResponseFromJSON(json: any): UpdateIcrTouchConnectionScheduleSitesConfigResponse {
    return UpdateIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json, false);
}

export function UpdateIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIcrTouchConnectionScheduleSitesConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigFromJSON(json['data']),
    };
}

  export function UpdateIcrTouchConnectionScheduleSitesConfigResponseToJSON(json: any): UpdateIcrTouchConnectionScheduleSitesConfigResponse {
      return UpdateIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(json, false);
  }

  export function UpdateIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(value?: UpdateIcrTouchConnectionScheduleSitesConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigToJSON(value['data']),
    };
}

